import(/* webpackMode: "eager" */ "/vercel/path0/src/app/catering/page.tsx");
